import { c as _c } from "react/compiler-runtime";
import { Step, StepLabel, Stepper, styled, type StepIconProps } from '@mui/material';
import { Icon } from '../shared/icon';
export const WizardStepper = t0 => {
  const $ = _c(5);
  const {
    activeStep,
    stepsLabels
  } = t0;
  let t1;
  if ($[0] !== stepsLabels) {
    t1 = stepsLabels.map(_temp);
    $[0] = stepsLabels;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== activeStep || $[3] !== t1) {
    t2 = <Stepper activeStep={activeStep} alternativeLabel={true} className="w-[80%] max-w-[1400px] mt-[12px] mb-[24px] mx-auto">{t1}</Stepper>;
    $[2] = activeStep;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const CircleStepIconWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 24,
  height: 24,
  borderRadius: '50%',
  backgroundColor: 'var(--mui-palette-background-paper)',
  // or default
  zIndex: 1
}));
function CircleStepIcon(props) {
  const $ = _c(3);
  const {
    completed,
    active
  } = props;
  let t0;
  if ($[0] !== active || $[1] !== completed) {
    t0 = <CircleStepIconWrapper>{completed ? <Icon iconClass="material-symbols-check" /> : <div className="w-[8px] h-[8px] rounded-full" style={{
        backgroundColor: completed || active ? "var(--mui-palette-primary-main)" : "var(--mui-palette-background-disabled)"
      }} />}</CircleStepIconWrapper>;
    $[0] = active;
    $[1] = completed;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
function _temp(label) {
  return <Step key={label}><StepLabel slots={{
      stepIcon: CircleStepIcon
    }} slotProps={{
      label: {
        className: "text-[12px] mt-[4px]"
      }
    }}>{label}</StepLabel></Step>;
}